module.exports = __webpack_public_path__ + "img/life-ring.96483620.svg";